import React, { useEffect, useState} from 'react'
import seqStore from '../../store/seqStore'

export default function Sequencer({ isRecording, isPlaying, gateLength, MIDIOutput}) {

  const maxLength = seqStore((state) => state.settings.maxLength)
  const currentTrack = seqStore((state) => state.settings.currentTrack)
  const length = seqStore((state) => state.settings.length)
  const melody = seqStore((state) => state.melody)
  const melody_scale = seqStore((state) => state.melody_scale)
  const scale = seqStore((state) => state.settings.scale)
  const ratchetPattern = seqStore((state) => state.settings.ratchetPattern)
  const setRatchetPattern = seqStore((state) => state.setRatchetPattern)
  const midiCh = seqStore((state) => state.settings.midiCh)
  const euclideanPattern = seqStore((state) => state.settings.euclideanPattern)
  const playhead = seqStore((state) => state.settings.playhead)
  const setPlayhead = seqStore((state) => state.setPlayhead)
  const semitone = seqStore((state) => state.settings.semitone)
  const octave = seqStore((state) => state.settings.octave)

  const [sequencer, setSequencer] = useState([])

  const sendNote = (msg, velocity, toothNumber) => {
    if (MIDIOutput) {
        setPlayhead(currentTrack, toothNumber)
        let note
        if (scale[currentTrack] !== 0) {
            note = melody_scale[currentTrack][toothNumber] + (octave[currentTrack] * 12) + semitone[currentTrack]
        } else {
            note = melody[currentTrack][toothNumber] + (octave[currentTrack] * 12) + semitone[currentTrack]
        }
        MIDIOutput.send(['0x9' + midiCh[currentTrack], note, velocity])
        MIDIOutput.send(['0x8' + midiCh[currentTrack], note, velocity], performance.now() + 300)
    }
  }

  useEffect(() => {
    const newSequencer = [];
    let deltaY = 0 // reset Y position for mouseMove

    for (let i = 0; i < maxLength; i++) {
        const isActive = euclideanPattern[currentTrack][i] === 1;
        let subSteps = null;

        if (ratchetPattern[currentTrack][i] !== 0 && isActive) {
            let count //ratchetPattern[currentTrack].length
            switch (ratchetPattern[currentTrack][i]) {
              case 1:
                count = 2
                break
              case 2:
                count = 3
                break
              case 3:
                count = 4
                break
              case -1:
                count = 2
                break
              case -2:
                count = 3
                break
              case -3:
                count = 4
                break
              case 0:
                count = 1
                break
            }
            subSteps = [];
            for (let j = 0; j < count; j++) {
                
              subSteps.push(
                <div
                    key={`subStep_${j}`}
                    id={`subStep_${j}`}
                    className='subStep'
                    style={{
                        backgroundColor: (playhead[currentTrack] === i ? "var(--clr_currentTrack)" : ratchetPattern[currentTrack][i] < 0 ? 'red' : 'green') //'#DFDBCE')
                    }}>
                </div>)
            }
        }

        newSequencer.push(
            <div
                className={ratchetPattern[currentTrack][i] !== 0 && isActive ? 'subStepWrapper' : 'step'}
                key={i}
                style={{
                    backgroundColor: isActive && ratchetPattern[currentTrack][i] === 0 ?
                        (playhead[currentTrack] === i && isRecording?'var(--clr_red)': playhead[currentTrack] === i && !isRecording? "var(--clr_currentTrack)"  : '#DFDBCE')
                        :
                        'transparent',
                    border: !isActive && '1px solid var(--clr_white_light)'
                }}
                //onMouseDown={() => {}}
                //onMouseUp={() => {}}
                onMouseMove={(e) => {
                  if (e.buttons === 1) { // Left mouse button is being held (dragging)
                    deltaY += e.movementY;
                    if (deltaY < -10) {
                        setRatchetPattern(currentTrack, i, Math.min(ratchetPattern[currentTrack][i] + 1, 3)); // Increment ratchet, limit to max 3
                        deltaY = 0;
                    } else if (deltaY > 10) {
                        setRatchetPattern(currentTrack, i, Math.max(ratchetPattern[currentTrack][i] - 1, -3)); // Decrement ratchet, limit to min -3
                        deltaY = 0;
                    }
                  }
                }}
                onMouseDown={() => {
                    if (!isPlaying) {
                        sendNote('0x9', 0x7f, i)
                    }
                }}
            >
                {subSteps}
            </div>
        )
    }
    setSequencer(newSequencer);
}, [length, melody, midiCh, playhead, ratchetPattern, currentTrack, euclideanPattern, gateLength, isPlaying]);


  
return (

    <>
      <div id='sequencerWrapper'>
        {sequencer}
      </div>
    </>
  )
}
